import React from "react";
import "./MultiSelect.scss";
import Select from "react-select";

const customStyles = {
  option: (provided, state) => ({
    // ...provided,
    borderBottom: "1px solid #F4F4F4",
    color: state.isSelected ? "white" : state.isFocused ? "black" : "black",
    padding: 20,
    borderRadius: 0,
    border: 0,
    fontSize: ".7em",
    textTransform: "uppercase",
    fontWeight: 600,
    background: state.isSelected
      ? "#0B0B0B"
      : state.isFocused
      ? "#EFEFEF"
      : "white"
  }),
  indicatorsContainer: provided => ({
    display: "flex",
    border: 0,
    margin: 0,
    padding: 0
  }),
  singleValue: provided => ({
    border: 0,
    margin: 0,
    font: "inherit",
    fontSize: ".9em",
    padding: 0,
    borderRadius: 0
  }),
  placeholder: provided => ({
    border: 0,
    margin: 0,
    font: "inherit",
    fontSize: ".9em",
    padding: 0,
    borderRadius: 0,
    opacity: ".65"
  }),
  input: provided => ({
    border: 0,
    margin: 0,
    font: "inherit",
    fontSize: ".9em",
    padding: 0,
    borderRadius: 0
  }),
  menuList: provided => ({
    margin: 0,
    borderRadius: 0,
    maxHeight: 234,
    overflow: "auto",
    padding: 0
  }),
  control: provided => ({
    display: "flex",
    borderRadius: 0,
    border: 0,
    borderBottom: "1px solid #F4F4F4"
  }),
  valueContainer: provided => ({
    ...provided,
    padding: 0,
    border: 0,
    borderRadius: 0,
    paddingBottom: 4
  }),
  container: provided => ({
    ...provided,
    font: "inherit",
    borderRadius: 0
  }),
  noOptionsMessage: provided => ({
    ...provided,
    padding: 20,
    borderRadius: 0,
    fontSize: ".7em",
    textTransform: "uppercase",
    fontWeight: 600
  }),
  menu: provided => ({
    ...provided,
    borderRadius: 0,
    border: 0
  }),
  multiValue: provided => ({
    ...provided,
    background: "#0B0B0B",
    color: "white",
    padding: "8px 8px 8px 16px",
    borderRadius: 24,
    alignItems: "center",
    marginRight: 4
  }),
  multiValueLabel: provided => ({
    fontSize: ".7em",
    color: "white",
    textTransform: "uppercase",
    fontWeight: 600
  }),
  multiValueRemove: provided => ({
    height: 16,
    width: 16,
    color: "black",
    background: "white",
    borderRadius: 24,
    display: "flex",
    marginLeft: 8,
    alignItems: "center",
    justifyContent: "center"
  })
};

// const options = [
//   { value: "graphic_design", label: "Graphic Design" },
//   { value: "illustration", label: "Illustration" },
//   { value: "user_experience", label: "User Experience" },
//   { value: "interface_design", label: "Interface Design" },
//   { value: "photography", label: "Photography" }
// ];

const S = ({
  type,
  label,
  name,
  required,
  value,
  onChange,
  options,
  limit
}) => (
  <div
    className="MultiSelect"
    data-disabled={value && value.length === limit ? true : false}
  >
    <label htmlFor={name}>
      {label}{" "}
      {limit && (
        <span data-limit={value && value.length === limit ? true : false}>
          {value && value.length ? value.length : 0}/{limit}
        </span>
      )}
    </label>
    <Select
      inputId={name}
      value={value}
      onChange={e => {
        onChange(name, e, limit);
      }}
      disabled={value && value.length === limit ? true : false}
      name={name}
      isMulti
      styles={customStyles}
      options={options}
    />
  </div>
);

export default S;
